import React, { PropTypes } from "react";

import styled from "styled-components";

const Content = styled.span`
  max-width: ${props => props.maxWidth + "px"};
  overflow:hidden;
  display:inline-block;
  word-wrap: break-word;
  white-space: normal;
`;

const TextWrap = ({ data, maxWidth }) => {
	return (
		<Content maxWidth={maxWidth}>
			{data}
		</Content>
	);
};

TextWrap.propTypes = {
	content: PropTypes.string,
	maxWidth: PropTypes.number
};

TextWrap.defaultProps = {
	maxWidth: "150"
};
export default TextWrap;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/TextWrap.js